export const modalPropsSelector = state => state.modal.modalProps;



// WEBPACK FOOTER //
// ./src/selectors/modalSelectors.js